// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__27OZ2","colCheckbox":"styles_colCheckbox__Bssa4"};